class AsyncCache {
  constructor () {
    this.cache = new Map()
  }

  /** @param {string} key */
  async get (key) {
    if (this.cache.has(key)) {
      return this.cache.get(key)
    }

    const data = await this.fetch(key)
    this.cache.set(key, data)

    return data
  }

  /** @param {string} key */
  async fetch (key) {}
}

class GiftWithPurchaseProductCache extends AsyncCache {
  /** @param {string} key */
  async fetch (key) {
    const [handle, variant] = key.split('::')

    const baseUrl = `${window.routes.rootUrl}/products`.replace(/\/\//g, '/')

    const { sectionRenderer } = window.BAO
    let url = `${baseUrl}/${handle}`
    if (variant) {
      url = `${url}?variant=${variant}`
    }

    const html = await sectionRenderer.fetchSingle(
      'gift-with-purchase-product',
      url,
    )

    return sectionRenderer.getInnerHtml(html, {
      id: 'shopify-section-gift-with-purchase-product',
    })
  }
}

class ProductCardCache extends AsyncCache {
  /** @param {string} handle */
  async fetch (handle) {
    const { sectionRenderer } = window.BAO
    const html = await sectionRenderer.fetchSingle(
      'product-card',
      `${window.Shopify.routes.root}products/${handle}`,
    )
    return sectionRenderer.getInnerHtml(html, {
      id: 'shopify-section-product-card',
    })
  }
}

class ProductDataCache extends AsyncCache {
  /** @param {string} handle */
  async fetch (handle) {
    const baseUrl = `${window.routes.rootUrl}/products`.replace(/\/\//g, '/')

    const response = await fetch(`${baseUrl}/${handle}.json`)

    return (await response.json()).product
  }
}

class QuickAddCache extends AsyncCache {
  /** @param {string} handle */
  async fetch (handle) {
    const { sectionRenderer } = window.BAO
    const html = await sectionRenderer.fetchSingle(
      'product-quick-add',
      `${window.Shopify.routes.root}products/${handle}`,
    )
    return sectionRenderer.getInnerHtml(html, {
      id: 'shopify-section-product-quick-add',
    })
  }
}

window.BAO.Caches = {
  giftWithPurchaseProductCache: new GiftWithPurchaseProductCache(),
  productCardCache: new ProductCardCache(),
  productDataCache: new ProductDataCache(),
  quickAddCache: new QuickAddCache(),
}
